import moment from 'moment'
import React from 'react'
import { useWatch } from 'react-hook-form'

import { SimpleGrid } from '@chakra-ui/react'

import { DatePicker, DummyInput, Input, Select } from '@/components/Form'

//Constant

import { ContributorGroupType } from '@/features/contributorGroups/constants'
import { useCustomer } from '@/features/customers/useCustomer'
import { offerSourcingGroupPolicyType } from '@/features/offers/constants/offerEditRights/offerSourcingEditRight'
import { selectOfferPermissions } from '@/features/offers/slices/offerDetail.slice'
import useUser from '@/features/users/useUser'
import { useSelector } from 'react-redux/'

//Helper

const SourcingGeneralInfo = () => {
  const offerPermissions = useSelector(selectOfferPermissions)

  const { useFetchAllUsers, useUserOptions } = useUser()
  const { useFetchAllCustomers } = useCustomer()

  const { data: allUserResponse } = useFetchAllUsers({
    page: 1,
    pageSize: 0,
    sortBy: 'fullName',
    orderBy: 1,
  })

  const { data: customerResponse } = useFetchAllCustomers({
    page: 1,
    pageSize: 0,
    filters: { status: 'active' },
  })

  const { data: procurementOfficerOptions } = useUserOptions({
    status: 'active',
    role: 'user',
    contributorGroup: ContributorGroupType.PROCUREMENT_OFFICER,
    valueKey: '_id',
  })

  const projectName = useWatch({ name: 'projectName' })
  const customerId = useWatch({ name: 'customer' })
  const endCustomerId = useWatch({ name: 'endCustomer' })
  const securityOfPayment = useWatch({ name: 'securityOfPayment' })
  const projectManager = useWatch({ name: 'manager' })
  const projectStartDate = useWatch({ name: 'projectStartDate' })
  const projectEndDate = useWatch({ name: 'projectEndDate' })

  const bookingProjectStartDate = useWatch({ name: 'booking.bookingStartDate' })
  const bookingProjectEndDate = useWatch({ name: 'booking.bookingEndDate' })
  const sales = useWatch({ name: `createdBy` })
  const bookingProjectManager = useWatch({ name: `booking.projectManager` })
  const firstSubSystemName = useWatch({ name: `subSystems.0.projectName` })

  const hasSecurityOfPayment = securityOfPayment ? 'Yes' : 'No'

  const salesName = Array.isArray(allUserResponse?.data)
    ? allUserResponse?.data.find((user) => user._id === sales)?.fullName
    : ''

  const customerName = Array.isArray(customerResponse?.data)
    ? customerResponse.data?.find((c) => c?._id === customerId)?.name
    : '(-)'
  const endCustomerName = Array.isArray(customerResponse?.data)
    ? customerResponse.data?.find((c) => c?._id === endCustomerId)?.name
    : '(-)'

  const canEditProcurementOfficer = offerPermissions[offerSourcingGroupPolicyType.SOURCING_COST_BUDGET]?.edit ?? false

  const canEditSourcingDueDate = offerPermissions[offerSourcingGroupPolicyType.SOURCING_DEADLINE]?.edit ?? false

  const displayManager = bookingProjectManager ? bookingProjectManager : projectManager

  const displayProjectManagerName = Array.isArray(allUserResponse?.data)
    ? allUserResponse?.data.find((user) => user._id === displayManager)?.fullName
    : ''
  const displayProjectStartDate = bookingProjectStartDate ? bookingProjectStartDate : projectStartDate
  const displayProjectEndDate = bookingProjectEndDate ? bookingProjectEndDate : projectEndDate

  return (
    <SimpleGrid columns={[2, null, 4]} spacingX="20px" spacingY="10px">
      <DummyInput label="End Customer" readOnly value={endCustomerName} isRow />
      <Input label="Customer PO" name="booking.customerPONumber" isRow disabled />

      <DatePicker
        name="sourcing.sourcingDueDate"
        label="Deadline of sourcing result"
        disabled={!canEditSourcingDueDate}
        isRow
      />
      <DatePicker name="booking.PODate" label="PO Date" disabled isRow />

      <DummyInput label="Project Start Date" value={moment(displayProjectStartDate).format('DD-MMM-YYYY')} isRow />
      <DummyInput label="Project End Date" value={moment(displayProjectEndDate).format('DD-MMM-YYYY')} isRow />

      <DummyInput label="Sales Responsible" readOnly value={salesName} isRow />
      <DummyInput label="Project Manager" readOnly value={displayProjectManagerName} isRow />

      <Select
        name="sourcing.procurementOfficer"
        label="Procurement Officer"
        disabled={!canEditProcurementOfficer}
        isRequired={false}
        options={procurementOfficerOptions ?? []}
        isRow
      />
    </SimpleGrid>
  )
}

export default SourcingGeneralInfo
